export default [
    {
        name: 'userlogList',
        path: '/userlog/list',
        component: require('@/pages/LogList').default,
        meta: {
            back: { label: 'Dashboard', to: '/' },
            security: (auth) => auth.can({ action: 'list', model: 'userlog' })
        }
    },
]
